import { AdminFetchAppListEndAction } from "../actions";
import { AdminState } from "../state";

export function fetchAppList(state: AdminState, action: AdminFetchAppListEndAction): AdminState {
    return { ...state, apps: action.payload.apps };
}
